import {
  AMBER_CLASS_NAME,
  AMBER_MAX_THRESHOLD,
  AMBER_MIN_THRESHOLD,
  RED_CLASS_NAME,
  RED_MIN_THRESHOLD,
} from '../constants';
import { AddConditionalClassOptions } from '../types';

export const addConditionalClass = ({
  value = 0,
  element,
  showCritical = false,
}: AddConditionalClassOptions): void => {
  if (showCritical && !value) {
    element.classList.add(RED_CLASS_NAME);
  } else if (value >= AMBER_MIN_THRESHOLD && value <= AMBER_MAX_THRESHOLD) {
    element.classList.add(AMBER_CLASS_NAME);
  } else if (value >= RED_MIN_THRESHOLD) {
    element.classList.add(RED_CLASS_NAME);
  }
};
